module.exports = "/legacy/47ae15f35b306df7ae6e14ad78c2bc53.svg";